import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'

const verticalMenuProps = {
  MenuListProps: {
    sx: {
      '&&': {
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },
}

const verticalMenuItemSx = {
  '&&': {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    textAlign: 'left',
    width: '100%',
  },
}

const ReferenceDataDropdown = ({ selectedReferenceType, setSelectedReferenceType, onEditMode }) => {
  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel id="reference-data-type-label">Reference Data Type</InputLabel>
      <Select
        labelId="reference-data-type-label"
        value={selectedReferenceType}
        onChange={(e) => setSelectedReferenceType(e.target.value)}
        label="Reference Data Type"
        MenuProps={verticalMenuProps}
        sx={{ '&& .MuiSelect-select': { textAlign: 'left' } }}
      >
        <MenuItem value="Industry Types" sx={verticalMenuItemSx}>Industry Types</MenuItem>
        <MenuItem value="Entity Types" sx={verticalMenuItemSx}>Entity Types</MenuItem>
        <MenuItem value="Service Types" sx={verticalMenuItemSx}>Service Types</MenuItem>
        <MenuItem value="Service Categories" sx={verticalMenuItemSx}>Service Categories</MenuItem>
        <MenuItem value="Contact Categories" sx={verticalMenuItemSx}>Contact Categories</MenuItem>
        <MenuItem value="Job Titles" sx={verticalMenuItemSx}>Job Titles</MenuItem>
      </Select>
    </FormControl>
  )
}

export default ReferenceDataDropdown
